import { useEffect, useState } from "react";
import api from "@/lib/api";

// BLOCK 92 — role-gated UI copy fetched from the server. Falls back to the
// SUBSCRIBER-safe wording if the request fails, so internal source/vendor
// names can never leak client-side.
const SUBSCRIBER_FALLBACK = {
  first_pass_tooltip:
    "Preliminary score based on public assessor records. This property hasn't been fully enriched with equity, mortgage and foreclosure data yet — the score reflects property-type and assessed-value signals only. It updates automatically once deeper financial data is added.",
  first_pass_tooltip_short:
    "Preliminary score from public assessor records — not yet enriched with equity/mortgage/foreclosure data. Reflects property-type and assessed-value signals only.",
  dashboard_mf_progress:
    "are still being enriched with deeper financial data and will appear here automatically as each one is fully scored.",
  dashboard_mf_empty:
    "No fully-enriched multifamily rows yet. Properties appear here automatically once their deeper financial data is scored.",
  dashboard_mf_scope: "fully-enriched properties shown · score ≥ 70",
  enrichment_heading:
    "Multi-source enrichment (demographics, filings, environmental & risk data)",
  census_unavailable:
    "Demographic data (median income, home value, owner-occupied %, vacancy rate, housing units) isn't available for this property yet.",
  property_panel_title: "Property Intelligence",
  property_panel_tooltip:
    "Property, valuation, assessment, foreclosure signals and sales history. Auto-enriched at higher scores; refreshed periodically.",
  property_panel_avm_label: "Estimated value (AVM)",
  property_panel_empty:
    "No property data yet. Enrichment pulls valuation, assessment and sales history.",
  property_panel_fallback:
    "Property data from a secondary provider (primary source unavailable)",
  sec_filings_label: "Public company filings",
};

let _cache = null;

export default function useUiCopy() {
  const [copy, setCopy] = useState(_cache || SUBSCRIBER_FALLBACK);
  useEffect(() => {
    if (_cache) {
      setCopy(_cache);
      return;
    }
    let alive = true;
    api
      .get("/ui-copy")
      .then((r) => {
        _cache = { ...SUBSCRIBER_FALLBACK, ...(r.data || {}) };
        if (alive) setCopy(_cache);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return copy;
}
